<style lang="less">
.verify{
	.id_img{
		padding: 20px 16px 10px;
		display: -webkit-box; display:flex;
		.img{
			position: relative;
			overflow: hidden;
			-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
			input{
				position: absolute;
				top: -100%;
				left: -100%;
				width: 300%;
				height: 300%;
			}
			&:first-child{
				margin-right: 6px;
			}
			img{
				width: 100%;
				height: 104px;
				background: #f1f1f1;
			}
		}
		.add{
			position: absolute;
			top: 50%;
			left: 50%;
			width: 20px;
			height: 20px;
			background: url(../assets/id_add.png)  no-repeat center center /100%;
			margin: -10px 0 0 -10px;
		}
		.close{
			position: absolute;
			width: 20px;
			height: 20px;
			top: 10px;
			right: 10px;
			background: url(../assets/id_del.png)  no-repeat center center /100%;
		}
	}
	.desc{
		padding-top: 40px;
		text-align: center;
		h3{
			padding-bottom: 11px;
			font-size: 16px;
		}
		p{
			padding-bottom: 5px;
			font-size: 12px;
			color: #999;
		}
	}
	.title{
		font-size: 16px;
		text-align: center;
		padding: 24px 0 18px 0;
	}
	.example{
		padding: 0 16px;
		display: -webkit-box; display:flex;
		.img{
			width: 161px;
			height: 104px;
			background: #f1f1f1;
			&:first-child{
				margin-right: 6px;
			}
			img{
				width: 100%;
				height: 104px;
			}
		}
	}
	.tips{
		color: #dc2a2a;
		font-size: 10px;
		padding: 0 16px;
	}
	.mr6{
		margin-right: 6px;
	}
}
</style>

<template>
	<!-- Main verify -->
	<section class="verify">
		<div class="desc">
			<h3>拍摄二代身份证原件</h3>
			<p>保持证件边框完整、身份信息清晰。</p>
			<p>照片信息仅用于开通“余额+”身份验证。</p>
		</div>
		<div class="id_img">
			<div class="img mr6" v-show="!identity.detail_info.img_f">
				<div class="add"></div>
				<img src="../assets/id_e.png" />
				<input type="file" accept="image/*" name="img_f" id="img_f" @change="selectImg" />
			</div>
			<div class="img mr6" v-show="identity.detail_info.img_f">
				<div class="close" @click="colseImg('img_f')"></div>
				<img :src="identity.detail_info.img_f" />
			</div>
			<div class="img" v-show="!identity.detail_info.img_b">
				<div class="add"></div>
				<img src="../assets/id_f.png" />
				<input type="file" accept="image/*" name="img_b" id="img_b" @change="selectImg" />
			</div>
			<div class="img" v-show="identity.detail_info.img_b">
				<div class="close" @click="colseImg('img_b')"></div>
				<img :src="identity.detail_info.img_b" />
			</div>
		</div>
		<div class="tips">
			<p>{{tips}} </p>
		</div>
		<h2 class="title">照片示例</h2>
		<div class="example">
			<div class="img">
				<img src="../assets/id_demo_e.jpg" />
			</div>
			<div class="img">
				<img src="../assets/id_demo_f.jpg" />
			</div>
		</div>

		<footbtn :btn-txt="btntxt" :is-on="isActive" v-on:next="next"></footbtn>
	</section>
</template>

<script>
	/*
		global track
	*/
	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import android from '@flyme/jr/js/android.js';

	// import toptips from '../components/toptips.vue';
	// import agreement from '../components/agreement.vue';
	// import itembank from '../components/itembank.vue';

	import axios from '../axios.js';
	import ajax from 'axios';
	import apis from '../apis.js';

	export default {
		data: function () {
			return {
				identity: {
					status: 100,
					identity_verify_id: '',
					detail_info:{
						img_b: '',
						img_f: ''
					}
				},
				userInfo: {},
				changed: false,
				tips: '',
				uploading: false,
				btntxt: '下一步',
				checkTimes: 0
			};
		},
		computed: {
			isActive: function() {
				if (this.identity.detail_info.img_b && this.identity.detail_info.img_f && this.changed) {
					return true;
				}else{
					return false;
				}
			},
			redirect() {
				return this.$route.query.redirect || '';
			}
		},
		components: {
			footbtn
		},
		created: function () {
			android('setTitle', {
				title:"验证身份"
			});

			// 带有跳转参数需要传给下一个
			if (this.redirect) {
				this.btntxt = '提交';
			}
		},
		mounted: function () {
			let _this = this;
			android('getUserInfo', {}, (d) => {
				_this.userInfo = d;
				_this.getIdentity();
			});
		},
		methods: {
			colseImg: function (key) {
				if (this.identity && this.identity.detail_info) {
					if (this.identity.detail_info[key]) {
						this.identity.detail_info[key] = '';
					}
				}
			},
			getIdentity: function () {
				let _this = this;

				axios.post(apis.identity_img_query, {
					show_type: 1,
					sys_reserved_info: '{"uid": '+ _this.userInfo.userId +'}'
				}).then(function(d) {
					console.log('identity_img_query', d);
					if (d.value && d.value.status == -1) {
						d.value.message = '';
					}
					_this.identity.status = d.value.status;
					_this.identity.identity_verify_id = d.value.identity_verify_id || '';
					if (d.value.detail_info.img_b) {
						_this.identity.detail_info.img_b = 'data:image/png;base64,' + d.value.detail_info.img_b;
					}
					if (d.value.detail_info.img_f) {
						_this.identity.detail_info.img_f = 'data:image/png;base64,' + d.value.detail_info.img_f;
					}
					_this.tips = d.value.message;
				});
			},
			selectImg: function (e) {
				let _this = this;
				this.changed = true;

				var key = e.target.name;
				var file = document.getElementById(key).files[0];
				var reader = new FileReader();
				reader.readAsDataURL(file);
				console.log(_this.identity.detail_info);
				reader.onload = function() {
					_this.identity.detail_info[key] = this.result;
				};
			},
			next: function () {
				let _this = this;
				if (this.uploading) {
					return;
				}
				_this.checkTimes = 0;

				var params = {
					'access_token': window.token,
					'version': '1.0',
					'sys_reserved_info': JSON.stringify({"uid": _this.userInfo.userId})
				};

				if (_this.identity.identity_verify_id) {
					params.identity_verify_id = _this.identity.identity_verify_id;
				}

				var form = new FormData();
				if (this.identity.status != -1) {
					params.type = 2;
				}else{
					params.type = 1;
				}
				if (document.getElementById('img_b').files[0]) {
					console.log('img_b success');
					form.append('img_b', document.getElementById('img_b').files[0]);
				}
				if (document.getElementById('img_f').files[0]) {
					console.log('img_f success');
					form.append('img_f', document.getElementById('img_f').files[0]);
				}


				var config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					},
					params: params
				};

				android('showLoadingDialog', {
					mes: '正在加载'
				});

				this.uploading = true;

				ajax.post(apis.identity_img_upload, form, config).then(function (d) {
					console.log('identity_img_upload', d, d.data.message);
					if (d.data.code != 200) {
						_this.uploading = false;
						_this.tips = d.data.message;
						android('hideLoadingDialog');
						_this.btntxt = '重新提交';
						track('event_ecash_identity_faild');
					}else{
						// track('event_ecash_identity_success');
						// _this.$router.replace({path: '/verify/result'});
						_this.checkStatus();
					}
				}).catch(res => {
					console.log(res);
					_this.uploading = false;
					android('hideLoadingDialog');
				});
			},
			checkStatus: function () {
				let _this = this;
				if (_this.checkTimes > 10) {
					_this.uploading = false;
					_this.btntxt = '重新提交';
					android('hideLoadingDialog');
					return;
				}
				axios.post(apis.identity_img_query, {
					show_type: 1,
					sys_reserved_info: '{"uid": '+ _this.userInfo.userId +'}'
				}).then(function(d) {
					console.log('identity_img_query loading', d);
					if (d.value && d.value.status == 30) {
						android('hideLoadingDialog');
						d.value.message = '';
						track('event_ecash_identity_success');
						if (_this.redirect) {
							_this.$router.replace({path: '/reverify/result', query: {redirect: _this.redirect}});
						} else {
							_this.$router.replace({path: '/verify/result'});
						}
					}else if(d.value && d.value.status == 10){
						_this.btntxt = '正在审核...';
						setTimeout(function () {
							_this.checkTimes++;
							_this.checkStatus();
						}, 5000)
					}else{
						android('hideLoadingDialog');
						_this.btntxt = '重新提交';
						_this.uploading = false;
						_this.tips = d.value.message;
					}
				});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Verify.vue